<template>
  <div class="popup_in">
    <div class="popup additional-codes-popup">
      <div class="popup_close close-animate">
        <a href="javascript:void(0);" @click.prevent="$emit('close')">
          <CloseSvg />
        </a>
      </div>

      <h2 class="title title--40">רופא יקר,</h2>
      <div class="popup-content">
        האם הפעולות הבאות יבוצעו במהלך הניתוח:
      </div>

      <div class="additional-codes-scroll">
        <table
          class="table table-striped table-policies additional-codes-table"
          cellspacing="0"
        >
          <thead>
            <tr>
              <th class="tx--white additional-codes-label">
                קוד ופירוט הפעולה
              </th>
              <th class="tx--white center">קבל</th>
              <th class="tx--white center">דחה</th>
            </tr>
          </thead>
          <tbody>
            <!-- Accepting a code adds it as is: the clinical (ICD9) code and
                 the duration are resolved before this popup opens, so there is
                 nothing left for the doctor to fill in here -->
            <tr v-for="(row, index) in localRows" :key="row.code">
              <td class="additional-codes-label">
                קוד {{ row.code }}, {{ row.label }}
              </td>
              <td class="center">
                <button
                  type="button"
                  class="additional-code-icon-btn"
                  :class="{ active: row.answer === 'accept' }"
                  title="קבל"
                  aria-label="קבל"
                  :aria-pressed="row.answer === 'accept'"
                  @click="setAnswer(index, 'accept')"
                >
                  <OkGreenSvg class="additional-code-icon" />
                </button>
              </td>
              <td class="center">
                <button
                  type="button"
                  class="additional-code-icon-btn"
                  :class="{ active: row.answer === 'reject' }"
                  title="דחה"
                  aria-label="דחה"
                  :aria-pressed="row.answer === 'reject'"
                  @click="setAnswer(index, 'reject')"
                >
                  <XRedSvg class="additional-code-icon" />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="flex flex--content--center">
        <a
          class="bt_blue"
          href="javascript:void(0)"
          :class="{ disabled: !allAnswered || isSaving }"
          @click.prevent="handleSave"
        >
          שמירה
          <vue-loaders-ball-clip-rotate
            v-show="isSaving"
            color="white"
            scale="1"
            style="position: relative;top: 6px;"
          ></vue-loaders-ball-clip-rotate>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import CloseSvg from "@/assets/img/svg/close.svg";
import OkGreenSvg from "@/assets/img/svg/ok-green.svg";
import XRedSvg from "@/assets/img/svg/x-red.svg";

export default {
  name: "AdditionalSurgeryCodesPrompt",
  components: {
    CloseSvg,
    OkGreenSvg,
    XRedSvg
  },
  props: {
    rows: {
      type: Array,
      required: true
    },
    onSave: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      // The resolved clinical code and duration ride along untouched - they are
      // read back by the parent when an accepted code is added
      localRows: this.rows.map(row => ({
        ...row,
        answer: null
      })),
      isSaving: false
    };
  },
  computed: {
    /** Saving requires every row to be either accepted or rejected */
    allAnswered() {
      return this.localRows.every(row => Boolean(row.answer));
    }
  },
  methods: {
    setAnswer(index, answer) {
      this.localRows[index].answer = answer;
    },

    async handleSave() {
      if (!this.allAnswered || this.isSaving) return;
      this.isSaving = true;
      try {
        await this.onSave(this.localRows);
      } finally {
        this.isSaving = false;
      }
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.additional-codes-popup {
  max-width: 560px;
  /* The modal is opened with height:"auto", so without a cap the popup grows
     past the viewport. Cap it (allowing for .popup_in's 50px padding) and let
     the table scroll, so the title and the save button stay visible. */
  max-height: calc(100vh - 120px);
  display: flex;
  flex-direction: column;
}

.popup-content {
  margin-bottom: 20px;
  font-size: 19px;
  line-height: 1.4;
}

.additional-codes-scroll {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  margin-bottom: 25px;
}

.additional-codes-table {
  width: 100%;
  font-size: 15px;
  /* Fixed layout keeps a long code description from widening the table
     (with auto layout the cell grows to the text's max-content width) */
  table-layout: fixed;
}

.additional-codes-table th:nth-child(2),
.additional-codes-table th:nth-child(3),
.additional-codes-table td:nth-child(2),
.additional-codes-table td:nth-child(3) {
  width: 70px;
}

.additional-codes-table td,
.additional-codes-table th {
  vertical-align: middle;
}

.additional-codes-table th {
  font-size: 17px;
}

.additional-codes-label {
  text-align: right;
  font-size: 16px;
  line-height: 1.4;
}

/* The icon is kept small so that the selected state's ring (a box-shadow, which
   sits outside the button's box) has room inside the row without growing it.
   Total footprint: 28px icon + 3px ring on each side = 34px. */
.additional-code-icon-btn {
  width: 28px;
  height: 28px;
  padding: 2px;
  /* Keeps the ring clear of the row's edges */
  margin: 4px 0;
  vertical-align: middle;
  border: none;
  border-radius: 50%;
  background: transparent;
  cursor: pointer;
  opacity: 0.55;
  transition: opacity 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.additional-code-icon-btn:hover {
  opacity: 0.85;
  box-shadow: 0 0 0 3px rgba(50, 73, 151, 0.1);
}

.additional-code-icon-btn:focus-visible {
  opacity: 0.85;
  outline: none;
  box-shadow: 0 0 0 3px rgba(50, 73, 151, 0.25);
}

/* Selected: full opacity plus the ring - no scaling, so the footprint stays
   the same whichever answer is chosen */
.additional-code-icon-btn.active {
  opacity: 1;
  box-shadow: 0 0 0 3px rgba(50, 73, 151, 0.18);
}

.additional-code-icon {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
